import { Typography, Box } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useEffect } from 'react';
import { Order } from '../../../../app/services/api/orderManagementClient';
import useCurrencyCodeConfiguration from '../../../../hooks/configurations/useCurrencyCodeConfiguration';
import { applyRoundAndFormat } from '../../../../utils';

interface SalesHeadlineProps {
  orders: Order[];
}

const SalesHeadline = ({ orders }: SalesHeadlineProps) => {
  const { currencyCode, getCurrencyCodeConfiguration } = useCurrencyCodeConfiguration();

  useEffect(() => {
    getCurrencyCodeConfiguration();
  }, []);

  // Calculate sales for current and previous month
  const now = new Date();
  const thisMonth = now.getMonth();
  const thisYear = now.getFullYear();
  const lastMonth = thisMonth === 0 ? 11 : thisMonth - 1;
  const lastMonthYear = thisMonth === 0 ? thisYear - 1 : thisYear;

  let currentMonthSales = 0;
  let previousMonthSales = 0;

  orders.forEach(order => {
    const deliveryDate = new Date(order.deliveryDate);
    if (deliveryDate.getFullYear() === thisYear && deliveryDate.getMonth() === thisMonth) {
      currentMonthSales += order.totalCost || 0;
    } else if (deliveryDate.getFullYear() === lastMonthYear && deliveryDate.getMonth() === lastMonth) {
      previousMonthSales += order.totalCost || 0;
    }
  });

  const change = currentMonthSales - previousMonthSales;
  const percentChange = previousMonthSales === 0 ? 0 : (change / previousMonthSales) * 100;
  const isPositive = change >= 0;

  return (
    <Box sx={{
      minWidth: '150px', textAlign: 'center', padding: '16px',
    }}>
      <Typography
        color="text.secondary"
        gutterBottom>
        Sales
      </Typography>
      <Typography
        component="h3"
        sx={{ fontWeight: 900, color: 'primary.main', my: 1 }}
      >
        {applyRoundAndFormat(currentMonthSales / 1000, currencyCode)}k
      </Typography>
      <Box display="flex"
        alignItems="center"
        justifyContent="center"
        mt={1}>
        {isPositive ? (
          <ArrowUpwardIcon color="success"
            fontSize="small" />
        ) : (
          <ArrowDownwardIcon color="error"
            fontSize="small" />
        )}
        <Typography
          component="div"
          color={isPositive ? 'success.main' : 'error.main'}
          sx={{ ml: 0.5 }}
        >
          {isPositive ? '+' : ''}{percentChange.toFixed(1)}%
        </Typography>
      </Box>
      <Typography
        component="div"
        color="text.secondary"
        sx={{ ml: 0.5 }}>
        vs last month
      </Typography>
    </Box>
  );
};

export default SalesHeadline;
